import { SpacingValue } from "../ComponentProps";

// This const/type approach is an alternative to enums that
// is supposed to be more efficient and reliable. babel also doesn't support
// const enums which is problematic.
export const TooltipDirection = {
  Top: "top",
  Left: "left",
  Right: "right",
  Bottom: "bottom",
} as const;

export declare type TooltipDirection = (typeof TooltipDirection)[keyof typeof TooltipDirection];

// Internal helper for passing around position data
export type TooltipPosition = Partial<{
  top?: SpacingValue;
  left?: SpacingValue;
  right?: SpacingValue;
  bottom?: SpacingValue;
  tail: { direction: TooltipDirection; offset?: number };
}>;
